import { useParams } from 'react-router-dom';

export function useGetAreaId() {
    const { areaId } = useParams();

    return parseInt(areaId);
}
